(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-rows/assets/javascripts/animations/huxflux.js') >= 0) return;  svs.modules.push('/components/tur/ball-rows/assets/javascripts/animations/huxflux.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.rows = svs.tur.ball.rows || {};
svs.tur.ball.rows.animations = svs.tur.ball.rows.animations || {};
const Events = svs.tur.ball.constants;
class HuxFlux {
  start(_ref) {
    let rows = _ref.rows,
      _ref$random = _ref.random,
      random = _ref$random === void 0 ? false : _ref$random;
    let rowsToHuxFlux = rows.rows.filter(row => row._huxfluxPrepared);
    if (rowsToHuxFlux.length) {
      let negativeDelay = 0;
      const tl = new TimelineLite({
        onStart: () => {
          rows.trigger(Events.HUXFLUX_STARTED);
        },
        onComplete: () => {
          rows.trigger(Events.HUXFLUX_COMPLETED);
        },
        onUpdate: () => {
          rows.trigger(Events.HUXFLUX_PROGRESS, Math.round(tl.progress() * 100) / 100);
        }
      });
      if (random) {
        rowsToHuxFlux = _.shuffle(rowsToHuxFlux);
        let _ballsToHuxFlux = [];
        rowsToHuxFlux.forEach(row => {
          _ballsToHuxFlux.push(_.flatten(row.balls));
        });
        _ballsToHuxFlux = _.shuffle(_.flatten(_ballsToHuxFlux));
        _ballsToHuxFlux.forEach(ball => {
          const huxfluxTL = ball.huxflux();
          if (huxfluxTL) {
            tl.add(huxfluxTL, "-=".concat(negativeDelay));
            negativeDelay = huxfluxTL.duration() * 0.98;
          }
        });
      } else {
        rowsToHuxFlux.forEach(row => {
          const huxfluxTL = row.huxflux({
            random
          });
          if (huxfluxTL) {
            tl.add(huxfluxTL, "-=".concat(negativeDelay));
            negativeDelay = huxfluxTL.duration() * 0.95;
          }
        });
      }
      return tl;
    }
    rows.error('You must prepare individual rows to huxflux!');
  }
}
svs.tur.ball.rows.animations.HuxFlux = new HuxFlux();

 })(window);